;(function ($) {

    const skip_menu_container = document.getElementById('skip_link_menus');
    const nav_menus = document.getElementsByClassName("widget_nav_menu");

    Array.prototype.forEach.call(document.querySelectorAll('.widget_nav_menu'), el => {

        let text = "Skip Sidebar Menu";

        if (el.getElementsByClassName("widgettitle")) {
            const inner_text = el
                .getElementsByClassName("widgettitle")[0]
                .innerText
                .replace(
                    /\w\S*/g,
                    function (txt) {
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    }
                );
            ;
            text = `Skip ${inner_text} Menu`;
        }

        skip_menu_container.insertAdjacentHTML(
            'beforeend',
            `<a href="#generic-main-container">${text}</a>`
        );

    });
    
;

})(jQuery);